module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event/event_frame-a95038baefe301517d800535ffde0137.jpg";